// Static fixture for the public /demo route.
// Mirrors a 5-employee Maltese tourism SME mid-engagement, matching the
// figures referenced in the Chamber case study. All values are illustrative;
// no live data is touched when the /demo route renders.

export const DEMO_CLIENT_ID = 'demo';

export const demoClient = {
  id: DEMO_CLIENT_ID,
  name: 'Colour my Travel (demo)',
  industry: 'Tourism',
  village: 'Valletta',
  organisationSize: 5,
  website: 'https://colourmytravel.example',
  billingName: 'Colour my Travel',
  billingEmail: 'accounts@colourmytravel.example',
  billingAddress: '12 Triq il-Mediterran, Valletta VLT 1234, Malta',
  vatNumber: 'MT12345678',
};

// Engagement phases. Matches the screenshot in the Chamber case study:
// 4 phases, 16 activities (5 done), 12 deliverables (1 delivered), 21% overall.
export const demoPhases = [
  {
    id: 'demo_phase_discovery',
    phaseId: 'discovery',
    name: 'Discovery',
    order: 1,
    startDate: '2026-03-18',
    endDate: '2026-05-31',
    status: 'in_progress',
    progress: 57,
    activities: [
      { id: 'a1', title: 'Stakeholder interviews',   completed: true  },
      { id: 'a2', title: 'Current state assessment', completed: true  },
      { id: 'a3', title: 'Technology audit',         completed: true  },
      { id: 'a4', title: 'Risk assessment',          completed: false },
    ],
    deliverables: [
      { id: 'd1', title: 'Current State Analysis', status: 'delivered'   },
      { id: 'd2', title: 'Stakeholder Map',        status: 'in_review'   },
      { id: 'd3', title: 'AI Readiness Report',    status: 'in_progress' },
    ],
  },
  {
    id: 'demo_phase_strategy',
    phaseId: 'strategy',
    name: 'Strategy',
    order: 2,
    startDate: '2026-04-01',
    endDate: '2026-06-15',
    status: 'in_progress',
    progress: 29,
    activities: [
      { id: 'a5', title: 'Vision workshops',        completed: true  },
      { id: 'a6', title: 'Use case identification', completed: true  },
      { id: 'a7', title: 'ROI analysis',            completed: false },
      { id: 'a8', title: 'Roadmap development',     completed: false },
    ],
    deliverables: [
      { id: 'd4', title: 'AI Strategy Document', status: 'pending' },
      { id: 'd5', title: 'Use Case Roadmap',     status: 'pending' },
      { id: 'd6', title: 'Business Case',        status: 'pending' },
    ],
  },
  {
    id: 'demo_phase_pilot',
    phaseId: 'pilot_planning',
    name: 'Pilot Planning',
    order: 3,
    startDate: '2026-06-16',
    endDate: '2026-07-31',
    status: 'not_started',
    progress: 0,
    activities: [
      { id: 'a9',  title: 'Pilot design',             completed: false },
      { id: 'a10', title: 'Resource allocation',      completed: false },
      { id: 'a11', title: 'Timeline creation',        completed: false },
      { id: 'a12', title: 'Risk mitigation planning', completed: false },
    ],
    deliverables: [
      { id: 'd7', title: 'Pilot Plan',                status: 'pending' },
      { id: 'd8', title: 'Success Metrics Framework', status: 'pending' },
      { id: 'd9', title: 'Resource Plan',             status: 'pending' },
    ],
  },
  {
    id: 'demo_phase_execution',
    phaseId: 'execution',
    name: 'Execution',
    order: 4,
    startDate: '2026-08-01',
    endDate: '2026-09-30',
    status: 'not_started',
    progress: 0,
    activities: [
      { id: 'a13', title: 'Implementation support',   completed: false },
      { id: 'a14', title: 'Training delivery',        completed: false },
      { id: 'a15', title: 'Progress reviews',         completed: false },
      { id: 'a16', title: 'Optimisation & iteration', completed: false },
    ],
    deliverables: [
      { id: 'd10', title: 'Training Materials',      status: 'pending' },
      { id: 'd11', title: 'Progress Reports',        status: 'pending' },
      { id: 'd12', title: 'Final Evaluation Report', status: 'pending' },
    ],
  },
];

export const demoDocuments = [
  {
    id: 'doc_workshop_report',
    name: 'AI Engagement Intervention Workshop Report',
    category: 'deliverable',
    type: 'application/pdf',
    url: '#demo',
    uploadedAt: '2026-05-06T10:00:00.000Z',
    uploadedBy: 'matthew.kenely',
  },
  {
    id: 'doc_readiness_report',
    name: 'Initial AI Readiness Report',
    category: 'deliverable',
    type: 'application/pdf',
    url: '#demo',
    uploadedAt: '2026-03-18T09:00:00.000Z',
    uploadedBy: 'matthew.kenely',
  },
  {
    id: 'doc_kickoff_notes',
    name: 'Kick-off Meeting Notes',
    category: 'meeting_notes',
    type: 'application/pdf',
    url: '#demo',
    uploadedAt: '2026-03-18T08:00:00.000Z',
    uploadedBy: 'matthew.kenely',
  },
];

export const demoSurveys = [
  {
    id: 'demo_survey_pre',
    title: 'AI Engagement Intervention Workshop (Pre)',
    description: '',
    isOpen: true,
    responseCount: 18,
    createdAt: '2026-05-06T08:00:00.000Z',
    databaseId: 'ai-readiness',
    tags: ['AI Readiness', 'Pre'],
  },
  {
    id: 'demo_survey_post',
    title: 'AI Engagement Intervention Workshop (Post)',
    description: '',
    isOpen: true,
    responseCount: 18,
    createdAt: '2026-05-06T08:30:00.000Z',
    databaseId: 'ai-readiness',
    tags: ['AI Readiness', 'Post'],
  },
];

export const demoDatabaseLookup = {
  'ai-readiness': 'AI Readiness',
};

export const demoUser = {
  displayName: 'Demo Visitor',
};
